import React, { Component } from "react"
import { Image, Button } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import NewTireImage from "../../../images/dashboard/new-tire.svg"
import SubtractBGImage from "../../../images/dashboard/subtract-bg.svg"

class BuyNewTireCard extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { t } = this.props
    return (
      <div className="buy-new-tire-card">
        <div className="buy-new-tire-card-content">
          <p className="buy-new-tire-text">{t("doYouNeedToChangeTireMsg")}</p>
          <a href="#/tire-size">
            <Button className="buy-new-tire-button">{t("buyNewTires")}</Button>
          </a>
        </div>
        <div className="buy-new-tire-card-images">
          <Image className="new-tire-image" src={NewTireImage} />
          <Image className="new-tire-bg-image" src={SubtractBGImage} />
        </div>
      </div>
    )
  }
}

export default withTranslation("justForYouCards")(BuyNewTireCard)
